// extracted by mini-css-extract-plugin
export var sendPageTitle = "LmY9ojEf4Sz4vk6agI0J";
export var sendSpinnerWrapper = "ybQ1wv_fCZV4UuMweAoQ";